import styled from 'styled-components';

const LineDecor = styled.div<{ $height: number }>`
	flex-shrink: 0;
	width: 2px;
	height: ${(props) => props.$height}px;
	background: linear-gradient(
		to right,
		rgba(255, 255, 255, 0.15) 0 1px,
		rgba(0, 0, 0, 0.2) 1px 2px
	);
`;

export { LineDecor };
